module.exports = __webpack_public_path__ + "static/img/funny_12.d0c6c466.jpg";